export default __webpack_public_path__ + "static/media/logo3.73c4ed56.png";